module.exports = __webpack_public_path__ + "static/media/Facebook_image.126c7d64.png";